<template>
  <!--  -->
  <div>
    <el-dialog
      title="申请转诊"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :center="true"
      :show-close="false"
      width="50%"
    >
      <span>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="申请时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.date1"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker
                  placeholder="选择时间"
                  v-model="ruleForm.date2"
                  value-format="HH:mm:ss"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            class="el-form-item-info"
            label="选择城市"
            prop="regionArr"
          >
            <div class="block">
              <el-cascader
                class="form-item-info"
                placeholder="请选择城市"
                v-model="ruleForm.regionArr"
                :options="cityList"
                :props="SetKey"
                @change="handleChange"
              ></el-cascader>
            </div>
          </el-form-item>
          <el-form-item
            class="el-form-item-info"
            label="所属医院"
            prop="toHospitalId"
          >
            <el-select
              class="form-item-info"
              v-model="ruleForm.toHospitalId"
              filterable
              placeholder="请选择所属医院"
              no-data-text="请选择所属医院"
              @change="getDepartment"
            >
              <el-option
                v-for="(item, index) in hospitalList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="el-form-item-info"
            label="所属科室"
            prop="toDepartmentId"
          >
            <!-- <el-select class="form-item-info" v-model="ruleForm.toDepartmentId" filterable placeholder="请选择所属科室" no-data-text="请选择所属科室">
        <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select> -->
            <el-input
              v-model="ruleForm.department"
              @focus="departmentResult = true"
              placeholder="请选择科室"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="转诊人">
            <el-input v-model="memberName" disabled></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="money">
            <el-input
              v-model.number="ruleForm.money"
              type="number"
              oninput="if(value<0)value=0"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传文件" prop="image">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :on-success="uploadSuccess"
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :file-list="fileArr"
              :limit="3"
              multiple
            >
              <i slot="default" class="el-icon-plus"></i>

              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible2">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="转诊原因" prop="cause">
            <el-input type="textarea" v-model="ruleForm.cause"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="departmentResult" width="40%" center>
      <DepartmentList @on_disease_code="on_disease_code" />
    </el-dialog>
  </div>
</template>
<script>
import DepartmentList from "@/components/departmentList/DepartmentList.vue";

import { setTransferAdd, getCityList, getHospital } from "@/api/index.js";

export default {
  components: { DepartmentList },
  data() {
    return {
      hospitalList: null,
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      dialogImageUrl: "",
      fileArr: [],
      dialogVisible: false,
      dialogVisible2: false,
      disabled: false,
      ruleForm: {
        cause: "",
        image: "", //附件图
        toHospitalId: "",

        regionArr: "",
        toDepartmentId: "",
        department: "",
        orderTreatId: "",
        date1: "",
        date2: "",
        money: 0,
      },
      memberName: "",
      rules: {
        cause: [{ required: true, message: "请填写转诊原因", trigger: "blur" }],
        toHospitalId: [
          { required: true, message: "请选择所属医院", trigger: "change" },
        ],
        department: [
          { required: true, message: "请选择所属科室", trigger: "change" },
        ],
        date1: [{ required: true, message: "请选择日期", trigger: "select" }],
        date2: [{ required: true, message: "请选择时间", trigger: "select" }],
        regionArr: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        money: [
          {
            type: "number",
            min: 0,
            max: 10000,
            message: "请设置金额",
            trigger: "blur",
          },
        ],
      },
      SetKey: {
        value: "id",
        label: "title",
        children: "children",
      },
      options: [],
      cityList: [],
      departmentResult: false,
    };
  },
  created() {
    this.getCityListInit(); //获取地区
  },
  methods: {
    on_disease_code(data, type) {
      console.log(data, type);
      this.departmentResult = type;
      this.ruleForm.toDepartmentId = data.id;
      this.ruleForm.department = data.name;
    },
    //城市点击方法
    handleChange(value) {
      this.ruleForm.regionId = value[2];
      this.ruleForm.toHospitalId = "";

      this.ruleForm.department = "";
      this.ruleForm.toDepartmentId = "";
      this.readyHospital(value[2]);
    },
    //获取地区
    getCityListInit() {
      getCityList().then((res) => {
        if (res.success) this.cityList = res.result;
      });
    },

    // 医院点击
    getDepartment() {
      let hid = this.ruleForm.toHospitalId;
      console.log("hid:", hid);

      // this.readyDepartment(hid);
    },
    /**
     * 获取所属医院
     */
    async readyHospital(area_id) {
      try {
        const that = this;
        const params = {
          areaId: area_id,
        };
        let res = await getHospital(params);
        if (res.success) {
          console.log(res);
          this.hospitalList = res.result;
          // if (that.ruleForm.toHospitalId == "") {
          //   that.ruleForm.toHospitalId =
          //     that.hospitalList.length > 0 ? that.hospitalList[0].id : null;
          // }
          // if (this.hospitalList.length == "") {
          //   //当更换城市后所属科室设为空，重新选择
          //   this.ruleForm.toDepartmentId = "";
          // }
          // this.readyDepartment(this.ruleForm.hospitalId);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    //限制上传数量
    handleExceed(files, fileList) {
      this.$message.error(`当前限制上传 3 份文件`);
    },
    //上传成功
    uploadSuccess(response, file, fileList) {
      this.fileArr = fileList;
      console.log(":", fileList);
    },
    //限制图片格式
    beforeAvatarUpload(file) {
      console.log("限制图片格式:", file.type);
      let isJPG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传文件只能是 JPG和PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //显示弹框
    open(item) {
      this.ruleForm.orderTreatId = item.id;
      this.memberName = item.caseContent_dictText.memberName;
      console.log("item:", item.caseContent_dictText.memberName);
      this.dialogVisible = true;
    },
    //隐藏弹框
    close() {
      this.ruleForm.hospital = "";
      this.dialogVisible = false;
      this.fileArr = [];

      this.$refs["ruleForm"].resetFields();
    },
    //删除图片
    handleRemove(file) {
      let { name } = file;
      this.fileArr.forEach((e, i) => {
        if (e.name == name) {
          this.fileArr.splice(i, 1);
        }
      });
    },
    //查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    //提交申请
    submitForm(formName) {
      let arr = [];
      if (this.fileArr.length != 0) {
        this.fileArr.forEach((e) => {
          arr.push(e.response.result.relativePath);
        });
      }
      this.ruleForm.image = arr.join(",");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {
            toHospitalId,
            toDepartmentId,
            image,
            cause,
            money,
            date1,
            date2,
            orderTreatId,
          } = this.ruleForm;

          let applyReferralTime = date1 + " " + date2;
          console.log('applyReferralTime:',applyReferralTime);
          setTransferAdd({
            money,
            applyReferralTime,
            toHospitalId,
            toDepartmentId,
            cause,
            orderTreatId,
            image
          }).then((res) => {
            if (res.success) {
              this.close();
              this.$message("患者生成待支付订单!");
              // this.$emit("success", this.ruleForm.orderTreatId);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.primary {
  background-color: #409eff !important;
  border: 1px solid #409eff !important;
}
/deep/.line {
  text-align: center;
}
</style>